const state = {
  modalVisible: false,
  modalComponent: null
}

const actions = {
  showModal ({ commit }, componentName) {
    commit('SHOW_MODAL', componentName)
  },

  hideModal ({ commit }) {
    commit('HIDE_MODAL')
  }
}

const mutations = {
  SHOW_MODAL (state, componentName) {
    state.modalVisible = true
    state.modalComponent = componentName
  },

  HIDE_MODAL (state) {
    state.modalVisible = false
  }
}

export default { namespaced: true, state, actions, mutations }
